export type Surface = string | { html?: string; css?: string; js?: string };
export type SurfaceMap = Record<string, Surface>;

export function parseSurfaceMap(raw: string | null | undefined): SurfaceMap {
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return {};
        return resolveSurfaceMap(parsed as Record<string, unknown>);
    } catch {
        return {};
    }
}

export function resolveSurfaceMap(map: Record<string, unknown> | null | undefined): SurfaceMap {
    if (!map || typeof map !== 'object') return {};
    const out: SurfaceMap = {};
    for (const [key, value] of Object.entries(map)) {
        if (value && typeof value === 'object' && typeof (value as { aliasOf?: unknown }).aliasOf === 'string') {
            const target = map[(value as { aliasOf: string }).aliasOf];
            if (target && !(typeof target === 'object' && 'aliasOf' in (target as object)))
                out[key] = target as Surface;
        } else {
            out[key] = value as Surface;
        }
    }
    return out;
}

export function isSurfacePresent(map: SurfaceMap, key: string): boolean {
    const surface = map[key];
    if (!surface) return false;
    if (typeof surface === 'string') return surface.length > 0;
    return !!(surface.html || surface.css || surface.js);
}
